module.exports = __webpack_public_path__ + "static/img/psychological_soothing.7517c2bc.png";